import {Component, ElementRef, EventEmitter, Output, ViewChild, inject} from '@angular/core';
import {DeliveryService} from "../../../../services/delivery.service";
import {catchError, finalize, takeUntil, tap} from "rxjs/operators";
import {EMPTY} from "rxjs";
import * as moment from "moment/moment";
import {ModalNalojkaInfoComponent} from "../../modals/modal-nalojka-info/modal-nalojka-info.component";
import {ModalNpDiscountInfoComponent} from "../../modals/modal-np-discount-info/modal-np-discount-info.component";
import {ModalInfoPaymentComponent} from "../../modals/modal-info-payment/modal-info-payment.component";
import {ModalCashOnDeliveryInfoComponent} from "../../modals/modal-cash-on-delivery-info/modal-cash-on-delivery-info.component";
import {MessageDeliveryNPConfirmComponent} from "../../messages/message-delivery-np-confirm/message-delivery-np-confirm.component";
import {ModalNpCompactPackInfoComponent} from "../../modals/modal-np-compact-pack-info/modal-np-compact-pack-info.component";
import {HttpClient} from "@angular/common/http";
import {LocalStorageService} from "../../../../services/local-storage.service";
import {Router} from "@angular/router";
import {MeestCities} from "../../../../interfaces/meest-cities";
import {MeestWarehouses} from "../../../../interfaces/meest-warehouses";
import {OrdersSuccessData} from "../../../../interfaces/orders-success-data";
import {OrganizationsService} from "../../../../services/organizations.service";
import {Organization} from "../../../../interfaces/organization";

@Component({
  selector: 'app-meest-express',
  templateUrl: './meest-express.component.html',
  styleUrls: ['../../../basket-confirm/basket-confirm.component.scss'],
})
export class MeestExpressComponent extends DeliveryService {
  @ViewChild('phoneRef') override phoneRef: ElementRef<HTMLInputElement>;
  @ViewChild('scrollInputRef') scrollInputRef: ElementRef<HTMLInputElement>;
  @ViewChild(ModalNalojkaInfoComponent) modalNalojkaInfoComponent: ModalNalojkaInfoComponent;
  @ViewChild(ModalNpDiscountInfoComponent) modalNpDiscountInfoComponentRef: ModalNpDiscountInfoComponent;
  @ViewChild(ModalInfoPaymentComponent) modalInfoPaymentComponentRef: ModalInfoPaymentComponent;
  @ViewChild(ModalCashOnDeliveryInfoComponent) modalCashOnDeliveryInfoComponentRef: ModalCashOnDeliveryInfoComponent;
  @ViewChild(MessageDeliveryNPConfirmComponent) messageDeliveryNPConfirmComponentRef: MessageDeliveryNPConfirmComponent;
  @ViewChild(ModalNpCompactPackInfoComponent) modalNpCompactPackInfoComponentRef: ModalNpCompactPackInfoComponent;
  @Output() selectedDeliveryType = new EventEmitter<number>();

  private organizationsService = inject(OrganizationsService);

  wrongDeliveryAddressStreet = false;
  wrongDeliveryAddressHouse = false;
  wrongDeliveryDepartmentNumber = false;
  wrongDeliveryDepartmentWeight = false;
  errorMessageDeliveryDepartmentWeight = '';
  wrongMeestDeliveryDiscount = false;
  showDeclaredPrice = true;
  wrongSumAfterPay = false;
  meestPostsResults;
  meestDeliveryPayment = -1;
  wrongMeestDeliveryPayment = false;
  wrongLastAddressOrganization = false;
  isSendPaymentAgree = false;
  timeMeestCity;
  // Номер останнього запиту підказок міста: пізня відповідь на старіший запит
  // (або вже після вибору міста) знову відкривала б список зі старим містом
  private meestCitySearchSeq = 0;
  meestCitySearchResults;
  sumAfterPay;
  reserve = false;
  beznal = false;
  meestCompactPack = false;
  meestCompactPackConfirm = false;
  meestCompactPackInfoMessageShow = false;
  showSumAfterPay = false;
  addressedDeliveryType = true;
  branchInCity = true;
  meestDeliveryDiscount = -1;
  deliveryDepartmentNumber = -1;
  wrongDeliveryMeestCity = false;
  reserveTimeOk = true;
  private isUserChangedDeliveryDate = false;
  public activeOrganization: Organization;

  constructor(
    http: HttpClient,
    localStorage: LocalStorageService,
    private router: Router
  ) {
    super(http, localStorage);

    this.organizationsService.organizations$
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((organizations: Organization[]) => {
        this.activeOrganization = organizations.find(org => org.is_active === '1' || org.is_active === true);
        if (this.activeOrganization && this.activeOrganization.type !== 'fiz') {
          this.meestDeliveryPayment = 0;
        }
      });
  }

  override scrollToInvalidForm() {
    if (this.wrongDeliveryMeestCity ||
      this.wrongMeestDeliveryPayment ||
      this.wrongEstimateOfTheCostOfTheOrder ||
      this.wrongDeliveryDepartmentNumber ||
      this.wrongDeliveryDepartmentWeight ||
      this.wrongSumAfterPay ||
      this.wrongLastAddressEdrpou ||
      this.wrongDeliveryDates) {
      this.scrollInputRef.nativeElement.scrollIntoView();
    } else if (!this.addressedDeliveryType) {
      if (this.wrongDeliveryAddressStreet || this.wrongLastAddressEdrpou) {
        this.scrollInputRef.nativeElement.scrollIntoView();
      }
    } else if (this.wrongMeestDeliveryDiscount) {
      this.scrollInputRef.nativeElement.scrollIntoView();
    }
  }

  inputMeestCity() {
    // текст міста змінено вручну - ref і відділення попереднього міста вже не про нього:
    // бек бере місто за meest_city_id, і замовлення йшло у старе місто
    if (this.lastAddress.meest_city_id) {
      this.lastAddress.meest_city_id = null;
      this.lastAddress.meest_branch_id = null;
      this.deliveryDepartmentNumber = -1;
      this.meestPostsResults = [];
      this.clearDepartmentWeightError();
    }

    this.validateInputMeestCity();

    clearTimeout(this.timeMeestCity);
    const seq = ++this.meestCitySearchSeq;

    this.timeMeestCity = setTimeout(() => {
      if (this.lastAddress.city.length > 2) {
        this.http.post(this.apiRoot + 'basket_data/get_meest_cities', {
          search: this.lastAddress.city,
        })
          .pipe(takeUntil(this.isDestroyed))
          .subscribe((data: MeestCities) => {
            if (seq !== this.meestCitySearchSeq) {
              return;
            }

            if (data && data.data) {
              this.meestCitySearchResults = data.data;
            } else {
              this.meestCitySearchResults = [];
            }
          });
      }
    }, 500);
  }

  meestSetCity(data) {
    // місто вибрано - підказки, що ще в дорозі чи чекають таймера, вже не потрібні
    clearTimeout(this.timeMeestCity);
    this.meestCitySearchSeq++;
    this.lastAddress.city = data.description;
    this.lastAddress.meest_city_id = data.ref;
    this.meestCitySearchResults = [];
    this.wrongDeliveryMeestCity = false;
    this.deliveryDepartmentNumber = -1;
    this.clearDepartmentWeightError();
    this.branchInCity = data.is_branch_in_city == '1';

    if (this.branchInCity) {
      this.meestSetWarehouses();
    } else {
      this.addressedDeliveryType = false;
    }
  }

  setMeestDeliveryTypeBranch() {
    if (!this.addressedDeliveryType) {
      this.addressedDeliveryType = true;
      this.deliveryDepartmentNumber = -1;
      this.clearDepartmentWeightError();
    }
    this.meestSetWarehouses();
  }

  setMeestDeliveryTypeAddress() {
    this.inputDeliveryAddressStreet();
    this.inputDeliveryAddressHouse();

    if (this.addressedDeliveryType) {
      this.addressedDeliveryType = false;
      this.clearDepartmentWeightError();
    }
  }

  inputDeliveryAddressStreet() {
    if (this.lastAddress.np_addr_street === null || this.lastAddress.np_addr_street.length <= 0) {
      this.wrongDeliveryAddressStreet = true;
      this.isValidDeliveryForm = true;
    } else {
      this.wrongDeliveryAddressStreet = false;
    }
  }

  inputDeliveryAddressHouse() {
    if (this.lastAddress.np_addr_house === null || this.lastAddress.np_addr_house.length <= 0) {
      this.wrongDeliveryAddressHouse = true;
      this.isValidDeliveryForm = true;
    } else {
      this.wrongDeliveryAddressHouse = false;
    }
  }

  crossClearAddressStreet() {
    this.lastAddress.np_addr_street = '';
    this.inputDeliveryAddressStreet();
  }

  crossClearAddressHouse() {
    this.lastAddress.np_addr_house = '';
    this.inputDeliveryAddressHouse();
  }

  crossClearAddressFlat() {
    this.lastAddress.np_addr_flat = '';
  }

  validateInputMeestCity() {
    if (!this.lastAddress.city || this.lastAddress.city.length < 3) {
      this.isValidDeliveryForm = true;
      this.wrongDeliveryMeestCity = true;
      this.meestCitySearchResults = [];
    } else {
      this.wrongDeliveryMeestCity = false;
    }
  }

  override validate() {
    if (this.lastAddress.meest_city_id && this.lastAddress.meest_branch_id) {
      this.deliveryDepartmentNumber = this.lastAddress.meest_branch_id;
      this.meestSetWarehouses();
    }

    if (this.lastAddress.np_addr_street && this.addressedDelivery) {
      this.addressedDeliveryType = false;
    } else if (this.lastAddress.meest_city_id && !this.lastAddress.meest_branch_id) {
      // як у НП: минуле замовлення без відділення, а адресну доставку вимкнено - форма відкривається
      // на «У відділення», і список відділень міста лишався порожнім, поки клієнт не перевибере місто
      this.meestSetWarehouses();
    }

    if (this.user.np_allow_beznal && this.lastAddress.yur_lico && this.lastAddress.edrpou) {
      this.beznal = true;
    }
  }

  meestSetWarehouses() {
    const cityRef = this.lastAddress.meest_city_id;

    this.http.post(this.apiRoot + 'basket_data/get_meest_branches', {
      city_ref: cityRef,
    })
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: MeestWarehouses) => {
        // Місто вже змінили: пізня відповідь показала б відділення старого міста,
        // і його meest_branch_id пішов би в замовлення з новим містом (як у НП)
        if (cityRef !== this.lastAddress.meest_city_id) {
          return;
        }

        if (data && data.data) {
          this.meestPostsResults = data.data;
        } else {
          this.meestPostsResults = [];
        }
      });
  }

  deliveryDepartmentNumberChange() {
    this.lastAddress.meest_branch_id = this.deliveryDepartmentNumber;
    this.clearDepartmentWeightError();

    this.deliveryDepartmentNumberValidation();
  }

  // Відповідь сервера про перевищення ваги стосується конкретного відділення:
  // зі зміною міста чи типу доставки вона вже не про те відділення, що вибране зараз.
  clearDepartmentWeightError() {
    this.wrongDeliveryDepartmentWeight = false;
    this.errorMessageDeliveryDepartmentWeight = '';
  }

  deliveryDepartmentNumberValidation() {
    if (this.deliveryDepartmentNumber == -1 || !this.deliveryDepartmentNumber) {
      this.wrongDeliveryDepartmentNumber = true;
      this.isValidDeliveryForm = true;
    } else {
      this.wrongDeliveryDepartmentNumber = false;
    }
  }

  inputSumAfterValidation() {
    if (!this.sumAfterPay || this.sumAfterPay < this.summaUah) {
      this.wrongSumAfterPay = true;
      this.isValidDeliveryForm = true;
    } else {
      this.wrongSumAfterPay = false;
    }
  }

  setMeestDeliveryPayment() {
    if (this.meestDeliveryPayment == 0) {
      this.wrongMeestDeliveryDiscount = true;
      this.meestDeliveryDiscount = -1;
      this.showSumAfterPay = false;
      this.showDeclaredPrice = true;
      this.sumAfterPay = '';
      this.inputEstimateOfTheCostOfTheOrder();
    } else if (this.meestDeliveryPayment == 1) {
      this.compensation = 0;
      this.showSumAfterPay = true;
      this.sumAfterPay = this.sumMarkupNalojka;
      this.showDeclaredPrice = false;
      this.wrongMeestDeliveryPayment = false;

      this.inputSumAfterValidation();
      if (this.user && this.user.do_not_show_exchange_rate_difference == 0) {
        this.modalNalojkaInfoComponent.show();
      }
    } else {
      this.showSumAfterPay = false;
      this.sumAfterPay = '';
      this.showDeclaredPrice = true;
      this.wrongMeestDeliveryPayment = false;
      this.wrongSumAfterPay = false;
      this.wrongMeestDeliveryDiscount = true;
    }

    this.setMeestDeliveryPaymentValidate();
  }

  setMeestDeliveryPaymentValidate() {
    if (this.meestDeliveryPayment == -1) {
      this.wrongMeestDeliveryPayment = true;
      this.isValidDeliveryForm = true;
    } else {
      this.wrongMeestDeliveryPayment = false;
    }
  }

  setMeestDeliveryDiscount() {
    if (this.meestDeliveryDiscount == 1) {
      if (this.beznal) {
        this.meestDeliveryBeznal();

      }

      this.showMeestDiscountModal()

      this.showSumAfterPay = false;
      this.wrongMeestDeliveryDiscount = false;
    }
    this.setMeestDeliveryDiscountChange();
  }

  setMeestDeliveryDiscountChange() {
    if (this.meestDeliveryDiscount == -1) {
      this.wrongMeestDeliveryDiscount = true;
      this.isValidDeliveryForm = true;
    } else {
      this.wrongMeestDeliveryDiscount = false;
    }
  }

  showMeestDiscountModal() {
    if (this.user && this.user.do_not_show_np_discount_info == 0) {
      this.modalNpDiscountInfoComponentRef.show();
    }
  }

  infoPaymentModal() {
    this.modalInfoPaymentComponentRef.infoPaymentModalShow();
  }

  inputSumAfterPay() {
    if (this.sumAfterPay < this.summaUah) {
      this.compensation = 0;
    } else {
      this.compensation = this.sumAfterPay - this.summaUah;
    }

    this.inputSumAfterValidation();
  }

  onUserChangeDeliveryDate() {
    this.isUserChangedDeliveryDate = true;
    this.changingValueDeliveryDate();
  }

  changingValueDeliveryDate() {
    const currentDate = moment().format('DD.MM.YYYY');
    const isCurrentDate = this.deliveryDate.toString() === currentDate;

    const now = new Date();
    const currentTime = now.getHours() * 60 + now.getMinutes();

    const startReserveTime = 0; // "00:00" в минутах
    const endReserveTime = 16 * 60 + 30; // "16:30" в минутах
    const currentTimeLessThen_16_30 = currentTime >= startReserveTime && currentTime < endReserveTime;

    if (this.deliveryDate == -1) {
      this.wrongDeliveryDates = true;
      this.isValidDeliveryForm = true;
    } else {
      this.wrongDeliveryDates = false;
    }

    this.reserveTimeOk = !(isCurrentDate && !currentTimeLessThen_16_30);
    // переключатель «Резерв» скрыт — сбрасываем, чтобы резерв не ушёл с заказом
    if (!this.reserveTimeOk) {
      this.reserve = false;
    }

    if (this.deliveryDate != -1 && this.deliveryCurrent && this.deliveryCurrent.delivery_hours && this.deliveryCurrent.delivery_hours[this.deliveryDate]) {
      this.deliveryHoursList = this.deliveryCurrent.delivery_hours[this.deliveryDate];
    } else {
      this.deliveryHoursList = [];
    }

    if (this.isUserChangedDeliveryDate) {
      this.deliveryHours = -1;
      this.wrongDeliveryHours = false;
      this.isUserChangedDeliveryDate = false;
    }
  }

  changingValueDeliveryHours() {
    if (!this.deliveryHoursList?.length) {
      this.wrongDeliveryHours = false;
      return;
    }

    if (this.deliveryHours == -1 && !this.dozakazDate) {
      this.wrongDeliveryHours = true;
      this.isValidDeliveryForm = true;
    } else {
      this.wrongDeliveryHours = false;
    }
  }

  meestGoodsReserve() {
    this.reserve = !this.reserve;
  }

  meestCompactPackInfoMessage() {
    this.meestCompactPackInfoMessageShow = !this.meestCompactPackInfoMessageShow;
  }

  toggleMeestCompactPack() {
    this.meestCompactPack = !this.meestCompactPack;
    this.meestCompactPackConfirm = false;

    if (this.meestCompactPack) {
      this.modalNpCompactPackInfoComponentRef.show();
    }
  }

  meestCompactPackAgree() {
    this.meestCompactPackConfirm = true;
  }

  meestCompactPackNotAgree() {
    this.meestCompactPack = false;
    this.meestCompactPackConfirm = false;
  }

  meestDeliveryBeznal() {
    this.inputLastAddressEdrpou();
    this.inputLastAddressOrganization();

    this.beznal = !this.beznal;

    if (this.beznal) {
      this.meestDeliveryDiscount = -1;
      this.wrongMeestDeliveryDiscount = true;
    }
  }

  inputLastAddressOrganization() {
    if (!this.lastAddress.organization || this.lastAddress.organization.length == 0) {
      this.wrongLastAddressOrganization = true;
      this.isValidDeliveryForm = true;
    } else {
      this.wrongLastAddressOrganization = false;
    }
  }

  crossClearAddressOrganization() {
    this.lastAddress.organization = '';
    this.inputLastAddressOrganization();
  }

  nalojkaNotAgree() {
    this.wrongMeestDeliveryPayment = true;
    this.meestDeliveryPayment = -1;
    this.showSumAfterPay = false;
    this.setMeestDeliveryPayment();
  }

  nalojkaNotShow() {
    this.http.get(this.apiRoot + 'basket_data/do_not_show_exchange_rate_difference_again')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(() => {
        this.user.do_not_show_exchange_rate_difference = 1;
      });
  }

  deliveryDiscountAgree() {
    this.beznal = false;
  }

  deliveryDiscountNotAgree() {
    this.wrongMeestDeliveryPayment = true;
    this.meestDeliveryPayment = -1;
  }

  deliveryDiscountNotShow() {
    this.http.get(this.apiRoot + 'basket_data/do_not_show_np_discount_info_again')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(() => {
        this.user.do_not_show_np_discount_info = 1;
      });
  }

  cashOnDeliveryInfoNotAgree() {
    this.wrongMeestDeliveryPayment = true;
    this.meestDeliveryPayment = -1;
    this.showSumAfterPay = false;
    this.setMeestDeliveryPayment();
    this.scrollToInvalidForm();
  }

  cashOnDeliveryInfoAgree() {
    this.isSendPaymentAgree = true;
    this.sendPayment();
  }

  cashOnDeliveryInfoNotShowMore() {
    this.http.get(this.apiRoot + 'basket_data/do_not_show_prepayment_notification_again')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(() => {
        this.isSendPaymentAgree = true;
        this.user.do_not_show_prepayment_notification = 1;
        this.sendPayment();
      });
  }

  switchesDeliveryType(id: number) {
    this.selectedDeliveryType.emit(id);
  }

  override validateSendPayment() {
    this.isValidDeliveryForm = false;
    const sendData = {
      delivery_id: this.delivery
    };

    this.validateInputMeestCity();

    // місто лише вписане, але не вибране зі списку (бек однаково відхилить 'empty meest city id')
    if (!this.lastAddress.meest_city_id) {
      this.isValidDeliveryForm = true;
      this.wrongDeliveryMeestCity = true;
    }

    sendData['meest_city_id'] = this.lastAddress.meest_city_id;

    if (!this.addressedDeliveryType) {
      this.inputDeliveryAddressStreet();
      this.inputDeliveryAddressHouse();
      sendData['np_addr_street'] = this.lastAddress.np_addr_street;
      sendData['np_addr_house'] = this.lastAddress.np_addr_house;
      // Квартира необов'язкова (приватний будинок, #580) - бек порожню приймає;
      // порожню шлемо порожнім рядком, а не null/«0»/«-».
      sendData['np_addr_flat'] = this.lastAddress.np_addr_flat ?? '';
    } else {
      this.deliveryDepartmentNumberValidation();
      sendData['meest_branch_id'] = this.deliveryDepartmentNumber;
    }

    // if (!this.user.only_prepayment) {
    //   this.setMeestDeliveryPaymentValidate();
    // }

    sendData['np_shipping_on_who'] = 0;
    sendData['reserved_by_user'] = 0;

    if (this.reserve && this.reserveTimeOk) {
      sendData['reserved_by_user'] = 1;
    }

    // if ((this.meestDeliveryPayment == 0 || this.user.only_prepayment) && !this.beznal) {
    //   if (this.liters >= this.user.np_big_delivery_liters) {
    //     sendData['np_shipping_on_who'] = 1;
    //   } else {
    //     this.setMeestDeliveryDiscountChange();
    //     sendData['np_shipping_on_who'] = this.meestDeliveryDiscount;
    //   }
    // }

    if (this.sumAfterPay) {
      sendData['summa_nalojki'] = this.sumAfterPay;
    }

    if (this.showSumAfterPay) {
      this.inputSumAfterValidation();
    }

    sendData['declared_price'] = this.declaredPrice;
    if (this.showDeclaredPrice && this.meestDeliveryPayment == 0 && (!this.activeOrganization || this.activeOrganization.type === 'fiz')) {
      this.inputEstimateOfTheCostOfTheOrder();
    }

    if (this.user.np_allow_beznal && this.beznal) {
      this.inputLastAddressEdrpou();
      this.inputLastAddressOrganization();
      sendData['edrpou'] = this.lastAddress.edrpou;
      sendData['organization'] = this.lastAddress.organization;
    }
    sendData['beznal'] = this.beznal;

    this.inputLastName();
    this.inputName();
    this.inputMiddleName();
    this.inputLastAddressPhone();
    this.changingValueDeliveryDate();
    this.changingValueDeliveryHours();

    sendData['compensation'] = 0;

    sendData['fio'] = `${this.lastName} ${this.name} ${this.middleName || ''}`;
    sendData['phone'] = this.phoneRef.nativeElement.value.replace(/\+38/g, '').replace(/\D/g, '');
    sendData['delivery_date'] = this.deliveryDate;

    sendData['delivery_hour'] = '';

    if (this.deliveryHoursList?.length && this.deliveryHours !== -1) {
      sendData['delivery_hour'] = this.deliveryHours;
    }

    sendData['comment'] = this.deliveryComment;

    // Дати переміщення бек рахує лише по підзамовних товарах: для кошика зі складів 1+7 без них список
    // порожній, а вибір обов'язковий - форма не відправлялась. Без delivery_date_zak бек бере delivery_date.
    if (this.separateOrders && this.deliveryCurrent?.delivery_dates_zak?.length) {
      this.changingValueDeliverySeparate();

      sendData['delivery_date_zak'] = this.deliverySeparate;
    }

    if (this.meestCompactPack && this.meestCompactPackConfirm) {
      sendData['np_compact_pack'] = true;
    }

    return sendData;
  }

  override sendPayment() {
    if (this.isSendingPayment) {
      return;
    }

    this.showOrderInProgressMessage = false;

    const sendData = this.validateSendPayment();

    if (!this.isValidDeliveryForm) {
      if (this.meestDeliveryPayment == 1 &&
        this.isSendPaymentAgree === false &&
        this.user.do_not_show_prepayment_notification == 0) {
        this.modalCashOnDeliveryInfoComponentRef.show();
        return;
      }

      this.isSendingPayment = true;
      let isAnswered = false;

      this.http.post(this.apiRoot + 'basket_data/pay', sendData, this.payRequestOptions)
        .pipe(
          takeUntil(this.isDestroyed),
          // замовлення створюється до відповіді - помилка/скасування = статус невідомий
          tap(() => isAnswered = true),
          catchError((response) => {
            isAnswered = true;
            this.notifyPayUnknown(response);

            return EMPTY;
          }),
          // finalize, а не сам subscribe: скасування лоадером і помилка HTTP
          // теж мають розблокувати кнопку
          finalize(() => {
            this.isSendingPayment = false;

            if (!isAnswered) {
              this.notifyPayUnknown();
            }
          })
        )
        .subscribe((data: OrdersSuccessData) => {
          if (this.orderInProgress(data)) {
            return;
          }

          if (data.error === '' && data.data.order_id) {
            data.data.delivery = this.delivery;
            this.isDeliveryConfirmation = true;
            this.messageDeliveryNPConfirmComponentRef.deliveryNPConfirmationShow(data);
          }

          if (data.error === 'empty basket') {
            this.router.navigate(['account']);
          }

          if (data.error === 'too many orders') {
            this.router.navigate(['account']);
          }

          if (data.error === 'not_enough_liters') {
            this.router.navigate(['basket']);
          }

          if (data.error === 'warehouse_weight') {
            this.wrongDeliveryDepartmentWeight = true;
            // Текст рахує сервер; якщо data не приїхала - показуємо власне пояснення,
            // інакше поле підсвітилось би помилкою без жодного тексту
            this.errorMessageDeliveryDepartmentWeight = (data.data && data.data.text)
              ? data.data.text
              : 'Вага замовлення перевищує ліміт відділення. Оберіть інше відділення.';
            this.scrollToInvalidForm();
          }

          this.notifyPayError(data);
        });
    } else {
      this.scrollToInvalidForm();
    }
  }
}
